require('../../../../vendor/angular-ux-datagrid.vendor');
require('angular-readable-time');
const uirouter = require('@uirouter/angularjs');
const ngIdle = require('ng-idle');
const angularSanitize = require('angular-sanitize');
const uiBootstrap = require('angular-ui-bootstrap');
const uiSelect = require('ui-select');
const relativeDate = require('angular-relative-date');
const coreModule = require('gw-um-grid-data-browser/gridDataBrowserModule.js');

/*@ngInject*/
const umExtensionsModule = angular.module('gw-um-extensions', [
    angularSanitize,
    ngIdle,
    uirouter.default,
    uiBootstrap,
    uiSelect,
    relativeDate.default.name,
    'currencyFilter',
    'isoCurrency',
    'dibari.angular-ellipsis',
    'ux',
    coreModule
])
    .config(function () {})
    .run(function (dynamicGridExtension) {
    });

require('./dynamicGrid.i18n.json');
require('./dynamicGrid.less');
require('./dynamicGrid.tpl.html');
require('./dynamicGridModal.tpl.html');
require('./dynamicGridModal.less');
require('./dynamicDataRepository.js');
require('./dynamicGridController.js');
require('./dynamicGridExtension.js');

module.exports = 'gw-um-extensions';
